import React from 'react';
import Icons from '../Icons/Icons.component';
import Tooltip from '../Tooltip/Tooltip.component';
import { AA_SURFACE } from '~/modules/Helper/contrast.helper';
import * as S from './Collapse.styled';

function obterTituloTooltip(isMobileTrigger, collapsed) {
  if (isMobileTrigger) {
    return collapsed ? 'Fechar menu' : 'Abrir menu';
  }
  return collapsed ? 'Expandir menu' : 'Recolher menu';
}

function obterIconeCollapse(isMobileTrigger, collapsed) {
  if (isMobileTrigger) {
    return collapsed ? Icons.MenuFoldOutlined : Icons.MenuUnfoldOutlined;
  }
  return collapsed ? Icons.MenuUnfoldOutlined : Icons.MenuFoldOutlined;
}

function Collapse({ collapsed, handleToggle, isMobileTrigger = false }) {
  const tooltipTitle = obterTituloTooltip(isMobileTrigger, collapsed);
  const IconComponent = obterIconeCollapse(isMobileTrigger, collapsed);
  const iconStyle = {
    fontSize: 18,
    color: AA_SURFACE,
  };

  function runToggle(event) {
    if (typeof handleToggle === 'function') {
      handleToggle(event);
    }
  }

  function handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    runToggle(event);
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      runToggle(event);
    }
  }

  return (
    <Tooltip title={tooltipTitle} placement="top">
      <S.CollapseTriggerWrapper
        $preencheArea={isMobileTrigger}
        role="button"
        tabIndex={0}
        aria-label={tooltipTitle}
        aria-expanded={isMobileTrigger ? collapsed : !collapsed}
        className="collapseButton"
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <IconComponent
          className="collapse-icon"
          style={iconStyle}
          aria-hidden
        />
      </S.CollapseTriggerWrapper>
    </Tooltip>
  );
}

export default Collapse;
